import Prism from "prismjs";
import "prismjs/components/prism-bash.js";
import "prismjs/components/prism-python.js";
import "prismjs/components/prism-json.js";
// React owns the DOM; never run Prism's automatic HTML rewriting.
Prism.manual = true;

const languages = {
  sh: "bash",
  shell: "bash",
  bash: "bash",
  javascript: "javascript",
  js: "javascript",
  python: "python",
  json: "json",
};

// Render token objects as escaped React text, never as injected HTML. Copy uses
// the original string, so highlighting cannot alter a command or credential.
export function syntaxTokens(text, language) {
  const grammar = Prism.languages[languages[language]];
  return grammar ? Prism.tokenize(String(text), grammar) : [String(text)];
}
